import { StatusBadge } from '@/ui/status-badge';
import { useTranslation } from 'react-i18next';

const statusConfig: Record<string, { color: 'emerald' | 'red' | 'amber' | 'blue' | 'gray' }> = {
  confirmed: { color: 'emerald' },
  cancelled: { color: 'red' },
  draft: { color: 'gray' },
  hold: { color: 'amber' },
  expired: { color: 'blue' },
};

export function ReservationStatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const config = statusConfig[status];
  if (!config) return null;
  return <StatusBadge color={config.color} label={t(`common.reservation.${status}`)} />;
}
